import type { TFunction } from "i18next";
import type { ConfirmOptions } from "../shell/emailBuilderConfirmTypes";

export function deleteConfirmOptions(t: TFunction, description: string): ConfirmOptions {
  return {
    title: t("Delete?"),
    description: t("Delete {{description}}? This can be undone with Undo.", { description }),
    confirmLabel: t("Delete"),
    destructive: true,
  };
}

export function groupDeleteConfirmOptions(t: TFunction): ConfirmOptions {
  return {
    title: t("Delete row group?"),
    description: t(
      "Delete this row group and all rows inside it? This can be undone with Undo.",
    ),
    confirmLabel: t("Delete"),
    destructive: true,
  };
}

export function ungroupConfirmOptions(t: TFunction): ConfirmOptions {
  return {
    title: t("Ungroup rows?"),
    description: t(
      "Split this row group into separate rows? Group styling will be removed. This can be undone with Undo.",
    ),
    confirmLabel: t("Ungroup"),
  };
}
